<template>
  <div class="div6 cutbox">
    <div class="text1">
      <p data-id="主标题1" data-range="4,6">{{ info.titles[0] }}</p>
    </div>
    <div class="text2">
      <p data-id="主标题2" data-range="4,6">{{ info.titles[2] }}</p>
    </div>
    <div class="text3" data-id="长特点1" data-range="9,19">{{ info.specialty[0] }}</div>
    <div class="text4">
      <img :src="info.image" alt="">
    </div>
    <div class="text5">
      <img src="../assets/img/div6-2.png" alt="">
      <span data-id="短特点1" data-range="4,11">{{ info.specialty_short[0] }}</span>
      <span data-id="短特点2" data-range="4,11">{{ info.specialty_short[1] }}</span>
    </div>
    <div class="text6" data-id="公司" data-range="8,26">{{ info.company }}</div>
  </div>
</template>
<script>

export default {
  name: 'TUWEN006',
  props: {
    info: Object
  },
  methods: {

  }
}
</script>
